const { useNavigate } = require("react-router");

export const useNavigatePage = () => {
  const nav = useNavigate();
  return function Navigation(to) {
    nav(to);
    window.scrollTo({ top: 0, behavior: "auto" });
  };
};
